module.exports = __webpack_public_path__ + "static/media/2-4-3_Spot_UV_Special_04.ab2ba82f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-4-3_Spot_UV_Special_04.jpg
// module id = 1731
// module chunks = 0